<template>
  <div id="vvvideo">
    <ul v-show="!isList" ref="uul">
      <li :class="{ active: now == item.channel }" v-for="(item, index) in list" :key="index">
        <div class="changchannel">通道{{ item.channel }}</div>
        <div class="changeTime" ref="abcdsg" @mousemove="move($event, item)">
          <div :title="utils.time(x.start * 1000, 'hhmmss') + '-' + utils.time(x.end * 1000, 'hhmmss')"
            v-for="(x, index) in item.times" :key="index" :style="widthPos(x.start, x.end)" class="changeTimes"
            @dblclick="getse(x)">
          </div>
        </div>
      </li>
      <div v-if="false" id="zhizhen" :style="{ left: zhizhen + 'px' }">
        <div>{{ title() }}</div>
      </div>
      <div id="zhizhen1" :style="{ left: zhizhen1 + 'px' }"></div>
    </ul>
    <videoList @playList="getse" @downList="$emit('downLoad',$event)" v-show="isList" :list="list"></videoList>
    <div v-if="isLoading" id="videoloading">
      数据加载中，预计需要({{ loadingTime }}秒)，发动机关有可能加载失败
    </div>
  </div>
</template>
<script>

var t;
import videoList from "./videoList.vue";
export default {
  props: ['isLoading', "model", "isList"],
  components: { videoList },
  data() {
    return {
      start: 1697575375,
      end: 1697589775,
      list: [
        {
          channel: 1,
          times: [],
        },
        {
          channel: 2,
          times: [],
        },
        {
          channel: 3,
          times: [],
        },
        {
          channel: 4,
          times: [],
        },
      ],
      now: 0,
      nowTime: 0,
      zhizhen: 50,
      zhizhen1: 50,
      allLength: 0, //整个轨道长度
      zzz: 200, //轨道距离左边的距离，用作鼠标位置计算
      isDblclick: false,
      allTimeLength: 0,//整个事件跨度
      loadingTime: 30,
      t: null,//计时器变量

    };
  },
  methods: {
    reach(start, end, list) {
      this.start = start;
      this.end = end;
      this.list = list;
      this.allTimeLength = this.end - this.start;
    },
    widthPos(s, e) {

      var width = ((e - s) * 100) / this.allTimeLength;
      var pos = ((s - this.start) * 100) / this.allTimeLength;
      return {
        width: width + "%",
        left: pos + "%",
      };
    },
    title(s, e) {
      //var a = this.utils.time(s * 1000, "hhmmss");
      //var b = this.utils.time(e * 1000, "hhmmss");
      return this.utils.time(this.nowTime * 1000, "hhmmss");
    },
    //获取开始和结束
    getse(b) {
      this.now = b.channel;
      var obj = {
        channel: this.now,
        start: this.nowTime,
        //start: b.start,
        end: b.end,
        device: b.device,
      };
      this.zhizhen1 = this.zhizhen;

      //clearTimeout(t);
      setTimeout(() => {
        if (!this.isDblclick) {
          this.$emit("play", obj);
        }
      }, 400);
      //
    },
    move(e, item) {
      this.zhizhen = e.x - this.zzz + 48;
      var m = (this.zhizhen - 48) / (this.allLength - 50);
      var all = this.end - this.start;
      this.nowTime = Math.floor(all * m + this.start);
    },
    alot(a, b) {
      this.isDblclick = true;
      this.$emit("alot", a, b);
      setTimeout(() => {
        this.isDblclick = false;
      }, 500);
    },
    jishiqi() {
      this.loadingTime = 30;
      this.t = setInterval(() => {
        if (v) {
          this.loadingTime--
        } else if (!v || this.loadingTime <= 0) {
          clearInterval(this.t)
        }
      }, 1000);
    }
  },
  mounted() {
    this.allLength = this.$refs.uul.offsetWidth;
    setTimeout(() => {
      var odiv = this.$refs.abcdsg[0];
      this.zzz = odiv.getBoundingClientRect().left;
    }, 200);

    // this.zzz=350;
  },
  watch: {

  }
};
</script>
<style lang="">
#vvvideo {
  width: 100%;
  height: 100%;
  position:relative;
  background:#fff
}
#vvvideo > ul {
  height: 100%;
  position: relative;
}
#vvvideo > ul #zhizhen {
  width: 1px;
  height: 100%;
  background: #86f72f;
  position: absolute;
  top: 0;
  z-index: 10;
}
#vvvideo > ul #zhizhen1 {
  width: 2px;
  height: 100%;
  background: #f0ff9d;
  position: absolute;
  top: 0;
  z-index: 10;
}
#vvvideo > ul #zhizhen > div {
  width: 50px;
  background: #e81a1a;
  padding: 2px;
  margin-left: -54px;
  display: none;
}
#vvvideo > ul:hover #zhizhen > div {
  display: block;
}
#vvvideo > ul > li {
  display: flex;
  height: 20px;
  border-bottom: solid 1px #a9a9a9;
}

#vvvideo > ul > li:hover,
#vvvideo > ul > li.active {
  background: #dee7fb;
}
#vvvideo > ul > li:first-child {
  border-top: solid 1px #a9a9a9;
}
#vvvideo > ul > li .changchannel {
  width: 50px;
  line-height: 2;
  border-right: solid 1px #a2a2a2;
  text-align: center;
}
#vvvideo > ul > li .changeTime {
  width: calc(100% - 50px);
  display: flex;
  position: relative;
}
#vvvideo > ul > li .changeTime .changeTimes {
  height: 100%;
  background: #7494ff;
  position: absolute;
}
#vvvideo > ul > li .changeTime .changeTimes:hover {
  background: #436aea;
  cursor: pointer;
}
#videoloading{
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  z-index:22;
  background:#fff;
  text-align:center;
  line-height:100px;
  font-size:14px;
}
</style>


// WEBPACK FOOTER //
// src/components/video/videoTool.vue